import { getNetworkedEntity } from "../utils/scene-graph";

AFRAME.registerComponent("hide-when-artwork-dimensions", {
  init() {
    this.baseVisible = this.el.object3D.visible;
    this.shouldHide = false;

    this._applyVisibility = this._applyVisibility.bind(this);
    this._updateFromArtwork = this._updateFromArtwork.bind(this);
    this._onComponentChanged = this._onComponentChanged.bind(this);
    this._onComponentInitialized = this._onComponentInitialized.bind(this);
    this._onExternalVisibilityChange = this._onExternalVisibilityChange.bind(this);

    this.el.addEventListener("visibilitychange", this._onExternalVisibilityChange);

    getNetworkedEntity(this.el).then(networkedEl => {
      this.targetEl = networkedEl;
      this._updateFromArtwork();

      this.targetEl.addEventListener("componentinitialized", this._onComponentInitialized);
      this.targetEl.addEventListener("componentchanged", this._onComponentChanged);
      this.targetEl.addEventListener("artwork-scaled", this._updateFromArtwork);
    });
  },

  remove() {
    this.el.removeEventListener("visibilitychange", this._onExternalVisibilityChange);

    if (!this.targetEl) return;

    this.targetEl.removeEventListener("componentinitialized", this._onComponentInitialized);
    this.targetEl.removeEventListener("componentchanged", this._onComponentChanged);
    this.targetEl.removeEventListener("artwork-scaled", this._updateFromArtwork);
  },

  _onExternalVisibilityChange(event) {
    if (!event || !event.detail || typeof event.detail.visible !== "boolean") {
      return;
    }

    this.baseVisible = event.detail.visible;
    this._applyVisibility();
  },

  _onComponentInitialized(event) {
    if (!event || event.detail !== "artwork") {
      return;
    }

    this._updateFromArtwork();
  },

  _onComponentChanged(event) {
    if (!event || !event.detail || event.detail.name !== "artwork") {
      return;
    }

    this._updateFromArtwork();
  },

  _hasDimensions() {
    if (!this.targetEl || !this.targetEl.components || !this.targetEl.components.artwork) {
      return false;
    }

    const artworkInfo = this.targetEl.components.artwork.data?.artworkInfo;

    if (!artworkInfo) {
      return false;
    }

    const dimensionKeys = ["dimensionsX", "dimensionsY", "dimensionsZ"];

    const hasDimensions = dimensionKeys.some(key => {
      const value = artworkInfo[key];

      if (value === undefined || value === null || value === "") {
        return false;
      }

      const numericValue = Number(value);
      return !Number.isNaN(numericValue) && numericValue > 0;
    });

    return hasDimensions;
  },

  _updateFromArtwork() {
    if (!this.targetEl) {
      return;
    }

    const hasDimensions = this._hasDimensions();

    if (this.shouldHide === hasDimensions) {
      this._applyVisibility();
      return;
    }

    this.shouldHide = hasDimensions;
    this._applyVisibility();
  },

  _applyVisibility() {
    const desiredVisible = this.baseVisible && !this.shouldHide;
    const currentVisible = this.el.object3D.visible;

    if (currentVisible !== desiredVisible) {
      this.el.object3D.visible = desiredVisible;
    }

    if (currentVisible === desiredVisible) {
      if (currentVisible !== this.baseVisible) {
        this.el.emit("visibilitychange", { visible: currentVisible });
      }
      return;
    }
    this.el.emit("visibilitychange", { visible: desiredVisible });
  }
});
